import { rgba } from "config/variable";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 270px;
  background-color: ${(props) => props.theme.bgcolordwhiteblack};
  padding: 12px;
  box-shadow: 0px 25px 40px -10px ${(props) => rgba(props.theme.colortileblack, 0.08)};
  border-radius: 8px;
`;
export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.multipleselectcolor};
  margin-bottom: 12px;
  .statusmsg {
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.bglightblue};
    border: 1px solid ${(props) => props.theme.bgborderlight};
    box-shadow: inset 1px 1px 0px
      ${(props) => rgba(props.theme.bgcolordwhite, 0.36)};
    border-radius: 8px;
    padding: 11px;
    justify-content: space-between;
    margin-top: 12px;
    span {
      font-weight: 400;
      font-size: 10px;
      line-height: 13px;
      color: ${(props) => props.theme.colorlightblack};
    }
    .ctaicons {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
`;
export const AvatarProfile = styled.div`
  display: flex;
  gap: 12px;
`;
export const UserDetails = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  .heading6 {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const MailIds = styled.div`
  display: flex;

  span {
    font-size: 9px;
    line-height: 13px;
    font-weight: 400;
    color: ${(props) => props.theme.textcolordarkgrey};
  }
`;

export const MeetingDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    white-space: nowrap;
    font-weight: 700;
    font-size: 10px;
    line-height: 13px;
    color: ${(props) => props.theme.colorlightblack};
  }
  .ant-select {
    width: 182px;
  }
  .ant-select-sm {
    .ant-select-selector {
      border-radius: 8px;
    }
  }
`;
export const MeetingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.multipleselectcolor};
  margin-bottom: 12px;
`;

export const AccountAction = styled.div`
  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 13px;
    .mobile-template {
      display: none;
      flex-direction: column; 
      @media (min-width: 0px) and (max-width: 820px) {
        display: flex;
      }
      label {
        font-weight: 400;
        font-size: 14px;
        margin-right: 15px;
        color: ${(props) => props.theme.textcolordblack};
        margin-bottom: 4px;
        display: block;
      }
      .usage {
        border: 1px solid ${(props) => props.theme.colorbluegreylight};
        border-radius: 8px; 
        padding: 10px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        color: ${(props) => props.theme.textcolordblack};
        span {
          display: block;
        }
      }
    }
  }

  .ctalinks {
    display: flex;
    gap: 12px;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${(props) => props.theme.colorlightblack};
    &:hover {
      color: ${(props) => props.theme.textcolordarkgrey};
    }
    .anticon {
      color: ${(props) => props.theme.colorbluegrey};
      font-size: 18px;
    }
  }
  .linkdanger {
    color: ${(props) => props.theme.colordanger};
    &:hover {
      color: ${(props) => props.theme.colordangerhover};
      .anticon {
        color: ${(props) => props.theme.colordangerhover};
      }
    }
    .anticon {
      color: ${(props) => props.theme.colordanger};
    }
  }
`;
